export class ThingsManufactureDetails{
    modelNumber : string;
    modelName : string;
    serialNumber : string;
    manufacturer : string;
    manufacturerUrl : string;

    constructor(modelNumber : string,
        modelName : string,
        serialNumber : string,
        manufacturer : string,
        manufacturerUrl : string){
            this.modelNumber = modelNumber;
            this.modelName = modelName;
            this.serialNumber = serialNumber;
            this.manufacturer = manufacturer;
            this.manufacturerUrl = manufacturerUrl;
        }
}